module.exports = __webpack_public_path__ + "static/media/Configuración_Puestos.97172fb0.svg";